import { Component, Input, OnInit } from '@angular/core';
import { IHotelBooking } from 'libraries/service/resources/model/search/hotel/IHotelBooking';
import { ILabels } from "../../../../../libraries/interfaces/ILabels";
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IHotelProperty } from "../../../../../libraries/service/resources/model/search/hotel/IHotelProperty";
import { IAddress } from "../../../../../libraries/hotel/models/address";
import { BehaviorSubject } from "rxjs";
import { IMomentDateFormat } from "../../../../../libraries/interfaces/IMomentDateFormat";

// tslint:disable-next-line:interface-name
interface BookingAddress {
    city: string;
    country: string;
    state?: string;
}

@Component({
    selector: 'booking-hotel',
    template: `
    <booking-header [booking]="booking" [processingId]="processingId">
        <div class="creation e2e-select-booking col-1-bottom">
            <div *ngFor="let property of booking.property">{{property.name}}</div>
            {{labels.created}} {{booking.whenCreated | dateMoment: dateFormat.momentMedium}}
            <span *ngIf="booking.agent && (booking.agent.firstName || booking.agent.lastName)">
                {{labels.by}} {{booking.agent?.firstName}} {{booking.agent?.lastName}}
            </span>
        </div>
        <div class="sector-date col-2-bottom">
            <div *ngFor="let property of bookingProperties">
                <ng-container *ngIf="property.country">
                    <span *ngIf="property.city">{{property.city}}</span>
                    <span *ngIf="property.state"> - {{property.state}}</span>
                    <span *ngIf="property.country"> - {{property.country}}</span>
                </ng-container>
            </div>
            <date-range [start]="booking.begin" [end]="booking.end"></date-range>
        </div>
    </booking-header>
    `,
})
export class BookingHotelComponent implements OnInit {
    // TODO make generic booking display in sasha
    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public booking: IHotelBooking;

    public dateFormat: IMomentDateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    public bookingProperties: BookingAddress[] = [];

    public input: BehaviorSubject<{ index: number, value: string }> = new BehaviorSubject<{ index: number, value: string }>({ index: 0, value: '' });

    public labels: ILabels = {
        created: Yii.t('wui-sasha-js', 'Créé le'),
        by: Yii.t('wui-sasha-js', 'par')
    };

    public ngOnInit(): void {
        this.bookingProperties = (this.booking.property || [])
            .filter((property: IHotelProperty): boolean => Boolean(property.address))
            .map((property: IHotelProperty): IAddress => property.address)
            .map((address: IAddress) : BookingAddress => {
                return {
                    city: address.city ? typeof address.city.name === 'string' ? address.city.name : address.city.name.value : undefined,
                    country: address.country?.name,
                    state: address.state !== undefined ? (typeof address.state === 'string' ? address.state : address.state.code) : undefined,
                };
            });
    }
}